package org.example.project.ui.screens

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.Icon
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import org.example.project.client.model.UserProfileResponse
import org.example.project.ui.icons.AppIcons
import org.example.project.ui.theme.EditorColors

@Composable
fun AccessDeniedScreen(
    user: UserProfileResponse,
    onLogout: () -> Unit,
    onNavigateToPlanner: (() -> Unit)? = null,
    modifier: Modifier = Modifier
) {
    Card(
        modifier = modifier
            .widthIn(max = 480.dp)
            .padding(horizontal = 16.dp, vertical = 40.dp),
        colors = CardDefaults.cardColors(containerColor = EditorColors.Surface),
        elevation = CardDefaults.cardElevation(defaultElevation = 2.dp),
        shape = RoundedCornerShape(16.dp),
        border = BorderStroke(1.dp, EditorColors.BorderSubtle)
    ) {
        Column(
            modifier = Modifier.padding(32.dp),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Surface(
                shape = RoundedCornerShape(999.dp),
                color = EditorColors.ErrorBg,
                modifier = Modifier.size(56.dp)
            ) {
                Box(contentAlignment = Alignment.Center) {
                    Icon(
                        imageVector = AppIcons.Lock,
                        contentDescription = null,
                        tint = EditorColors.ErrorSolid,
                        modifier = Modifier.size(26.dp)
                    )
                }
            }

            Spacer(modifier = Modifier.height(16.dp))

            Text(
                text = "Brak uprawnień redakcyjnych",
                fontSize = 20.sp,
                fontWeight = FontWeight.Bold,
                color = EditorColors.ErrorSolid,
                textAlign = TextAlign.Center
            )

            Spacer(modifier = Modifier.height(12.dp))

            Surface(
                shape = RoundedCornerShape(10.dp),
                color = EditorColors.SurfaceSubtle,
                border = BorderStroke(1.dp, EditorColors.BorderSubtle),
                modifier = Modifier.fillMaxWidth()
            ) {
                Row(
                    modifier = Modifier.padding(14.dp),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Icon(
                        imageVector = AppIcons.Users,
                        contentDescription = null,
                        tint = EditorColors.TextSecondary,
                        modifier = Modifier.size(20.dp)
                    )
                    Spacer(modifier = Modifier.width(10.dp))
                    Column {
                        Text(
                            text = user.displayName,
                            fontSize = 13.sp,
                            fontWeight = FontWeight.SemiBold,
                            color = EditorColors.TextPrimary
                        )
                        user.email?.let { email ->
                            Text(
                                text = email,
                                fontSize = 12.sp,
                                color = EditorColors.TextMuted
                            )
                        }
                    }
                }
            }

            Spacer(modifier = Modifier.height(16.dp))

            Text(
                text = "Twoje konto nie posiada roli administratora (`admin`) ani uprawnienia `catalog.activities.manage`. Dostęp do panelu edytora został zablokowany ze względów bezpieczeństwa.",
                fontSize = 13.sp,
                color = EditorColors.TextSecondary,
                textAlign = TextAlign.Center,
                lineHeight = 18.sp
            )

            Spacer(modifier = Modifier.height(24.dp))

            if (onNavigateToPlanner != null) {
                Button(
                    onClick = onNavigateToPlanner,
                    modifier = Modifier
                        .fillMaxWidth()
                        .height(44.dp),
                    shape = RoundedCornerShape(10.dp),
                    colors = ButtonDefaults.buttonColors(
                        containerColor = EditorColors.Primary,
                        contentColor = EditorColors.Surface
                    )
                ) {
                    Icon(
                        imageVector = AppIcons.Planner,
                        contentDescription = null,
                        modifier = Modifier.size(16.dp)
                    )
                    Spacer(modifier = Modifier.width(8.dp))
                    Text("Przejdź do Planera eventów", fontSize = 13.sp, fontWeight = FontWeight.SemiBold)
                }
                Spacer(modifier = Modifier.height(10.dp))
            }

            OutlinedButton(
                onClick = onLogout,
                modifier = Modifier
                    .fillMaxWidth()
                    .height(44.dp),
                shape = RoundedCornerShape(10.dp),
                colors = ButtonDefaults.outlinedButtonColors(
                    contentColor = EditorColors.TextSecondary
                ),
                border = BorderStroke(1.dp, EditorColors.BorderStrong)
            ) {
                Text("Wyloguj", fontSize = 13.sp, fontWeight = FontWeight.SemiBold)
            }
        }
    }
}
